const buildGoogleMapsUrl = (lat, lng) => {
  return `https://www.google.com/maps?q=${encodeURIComponent(`${lat},${lng}`)}`;
};

const parseCoordinate = (value) => {
  const trimmed = value.trim();
  if (trimmed === "") return null;

  const number = Number(trimmed);
  return Number.isFinite(number) ? number : null;
};

const updateGoogleMapsLink = (link, latInput, lngInput) => {
  const latNumber = parseCoordinate(latInput.value);
  const lngNumber = parseCoordinate(lngInput.value);

  if (latNumber !== null && lngNumber !== null &&
      latNumber >= -90 && latNumber <= 90 &&
      lngNumber >= -180 && lngNumber <= 180) {
    link.href = buildGoogleMapsUrl(latNumber, lngNumber);
    link.classList.remove("hidden");
  } else {
    link.href = "#";
    link.classList.add("hidden");
  }
};

const updateMessage = (messageEl, text, type = "error") => {
  messageEl.textContent = text;
  messageEl.className = "text-sm min-h-[1.25em]";
  if (text) {
    messageEl.classList.add(type === "error" ? "text-red-600" : "text-green-600");
  }
};

export const setupAdminSpotForm = () => {
  const addressInput = document.getElementById("spot-address-input");
  const geocodeButton = document.getElementById("spot-geocode-button");
  const latInput = document.getElementById("spot-latitude-input");
  const lngInput = document.getElementById("spot-longitude-input");
  const messageEl = document.getElementById("spot-geocode-message");
  const mapsLink = document.getElementById("spot-google-maps-link");

  if (!addressInput || !geocodeButton || !latInput || !lngInput || !messageEl || !mapsLink) return;

  updateGoogleMapsLink(mapsLink, latInput, lngInput);

  latInput.addEventListener("input", () => updateGoogleMapsLink(mapsLink, latInput, lngInput));
  lngInput.addEventListener("input", () => updateGoogleMapsLink(mapsLink, latInput, lngInput));

  geocodeButton.addEventListener("click", async () => {
    const query = addressInput.value.trim();
    if (query === "") {
      updateMessage(messageEl, "住所を入力してください");
      return;
    }

    updateMessage(messageEl, "");
    geocodeButton.disabled = true;

    try {
      const url = new URL(geocodeButton.dataset.geocodingUrl, window.location.origin);
      url.searchParams.set("q", query);

      const response = await fetch(url.toString(), { headers: { Accept: "application/json" } });
      const data = await response.json();

      if (response.ok && data.status === "OK") {
        latInput.value = data.lat;
        lngInput.value = data.lng;
        updateMessage(messageEl, "緯度経度を取得しました", "success");
        updateGoogleMapsLink(mapsLink, latInput, lngInput);
      } else {
        const statusText = data.status || "UNKNOWN";
        updateMessage(messageEl, `緯度経度の取得に失敗しました (${statusText})`);
      }
    } catch {
      updateMessage(messageEl, "緯度経度の取得に失敗しました");
    } finally {
      geocodeButton.disabled = false;
    }
  });
};

document.addEventListener("DOMContentLoaded", setupAdminSpotForm);
